<template>
  <b-container fluid>
    <b-row class="mb-3">
      <b-col cols="12">
        <PageHeader :title="$cte('profile.profile')" />
      </b-col>
    </b-row>

    <b-tabs class="font-jumper" @activate-tab="onTabActivated">
      <b-tab
          title="Adataim"
          class=""
          style=""
      >
        <b-row class="mt-3">
          <b-col cols="12">
            <b-overlay
              :show="userLoading"
              rounded="sm"
              spinner-variant="success"
              spinner-type="grow"
            >
              <div class="">
                <template>
                  <b-container fluid class="m-0 p-0">
                    <b-row class="">
                      <b-col sm="12" md="8" lg="6">
                        <b-button-group class="mb-3">
                          <b-button
                            @click="() => (selectedForm = 'company')"
                            :class="{ active: selectedForm === 'company' }"
                          >
                            {{ $cte("profile.company") }}
                          </b-button>
                          <b-button
                            @click="() => (selectedForm = 'user')"
                            :class="{ active: selectedForm === 'user' }"
                          >
                            {{ $cte("profile.user") }}
                          </b-button>
                        </b-button-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12">
                        <UserEditor
                          :user-data="userData"
                          @userSave="saveUser"
                          v-if="selectedForm === 'user'"
                        />
                        <CompanyEditor
                          :company-id="getActiveCompany.id"
                          v-if="selectedForm === 'company'"
                        />
                      </b-col>
                    </b-row>
                  </b-container>
                </template>
              </div>
            </b-overlay>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab
          :title="$cte('nav.navConnection')"
          lazy
          class=""
          style=""
      >
        <div class="mt-3">
          <nav-technical-user />
        </div>
      </b-tab>
      <b-tab
          title="Számlázó bekötés"
          lazy
          class=""
          style=""
      >
        <div class="mt-3">
          <invoicing-connection />
        </div>
      </b-tab>
      <b-tab
          title="Előfizetés"
          class=""
          style=""
          v-if="!isPWAMode()"
      >
        <div class="mt-3 ">
          <payment-details />
        </div>
      </b-tab>

      <b-tab title="Jelszó megváltoztatása" class="" lazy>
        <password-change-component />
      </b-tab>
    </b-tabs>

    <!-- Build version display -->
    <b-row v-if="buildVersion" class="mt-4">
      <b-col cols="12" class="text-center">
        <small class="text-muted">Build: {{ buildVersion }}</small>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Api from "api-client";
import PageHeader from "../../../components/PageHeader";
import { mapActions, mapGetters } from "vuex";
import NavTechnicalUser from "./NavTechnicalUser.vue";
import InvoicingConnection from "../invoicing/InvoicingConnection.vue";
import UserEditor from "@/views/app/profile/UserEditor";
import CompanyEditor from "@/views/app/profile/CompanyEditor";
import PasswordChangeComponent from "@/components/profile/PasswordChangeComponent.vue";
import PaymentDetails from "@/views/app/profile/PaymentDetails.vue";

export default {
  name: "UserProfile",
  components: {
    PaymentDetails,
    PasswordChangeComponent,
    CompanyEditor,
    UserEditor,
    PageHeader,
    NavTechnicalUser,
    InvoicingConnection,
  },
  data() {
    return {
      userLoading: false,
      navLoading: false,
      userData: {},
      userDataFromServer: {},
      profileInputKey: 0,
      selectedForm: "company"
    };
  },
  computed: {
    ...mapGetters("app", ["getActiveCompany"]),
    buildVersion() {
      return this.$route.query.build || sessionStorage.getItem('pwa_build_version') || null;
    },
  },
  methods: {
    ...mapActions("app", ["login"]),

    saveUser(userData) {
      Api.saveUser(userData)
        .then(() => {
          this.$toast.success({
            title: this.$cte("toast.modify-success"),
            message: this.$cte("toast.modify-success"),
          });
          this.userLoading = false;
          this.getUserData();
        })
        .catch(() => {
          this.userLoading = false;
          this.$toast.error({
            title: this.$cte("toast.modify-failed"),
            message: this.$cte("toast.modify-failed"),
          });
          this.getUserData();
        });
    },

    getUserData() {
      let self = this;
      Api.getCurrentUser()
        .then((resp) => {
          self.userLoading = false;
          self.userData = self.userDataFromServer = resp.data;
          self.profileInputKey++;
        })
        .catch(() => {
          self.userLoading = false;
          self.profileInputKey++;
          self.$toast.error({
            title: self.$cte("profile.failedGet"),
            message: self.$cte("profile.failedToGetData"),
          });
        });
    },

    isPWAMode() {
      return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
    },

    onTabActivated(newTabIndex) {
      console.log('Tab activated:', newTabIndex);
    },
  },
  created() {
    this.getUserData();
  },
};
</script>

<style scoped>
.company-icon {
  width: 150px;
  height: 150px;
  max-width: 150px;
  max-height: 150px;
  color: #ffffff;
  border-radius: 50%;
  font-size: 100px;
}

.profile-buttons {
  width: 175px !important;
}

.bold-text {
  font-weight: 600;
}

.caption {
  font-variant: small-caps;
}

.form-toggle {
  cursor: pointer;
  width: 20rem;
  display: flex;
  background-color: #e4e9ef;
  justify-content: space-around;
  border-radius: 5px;
  font-variant: small-caps;
}

.form-toggle > div {
  flex: 0 0 50%;
  max-width: 50%;
  padding: 0.2rem;
  text-align: center;
  font-weight: bold;
  font-size: 1.5rem;
  color: #5bb65d;
  border-radius: 5px;
}

.form-toggle > .active {
  color: #ffffff;
  background-color: #5bb65d !important;
}

.btn-group .btn-secondary.active {
  background-color: #b2ec5d !important;
  color: #252734 !important;
}
</style>
